<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 pa-1 v-for="region in regions" :key="region.id">
                <v-card>
                    <v-toolbar flat color="primary" dark height="40" >
                        <v-toolbar-title>{{region.id}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn small @click.prevent='onEditRegion(region.id)'
                            light>Edit</v-btn>
                    </v-toolbar>
                    <v-list dense>
                        <v-list-tile>
                        <v-list-tile-content class="body-2">Name</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ region.name }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                        <v-list-tile-content class="body-2">Import Source</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ region.source }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                        <v-list-tile-content class="body-2">Active</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ region.active ? "Active" : "Inactive" }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                        <v-list-tile-content class="body-2">Manager</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ region.managerName }}</v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <v-layout row wrap v-if="region.territories" px-2>
                        <v-flex body-2 xs12 >Territories</v-flex>
                        <v-flex xs4 v-for="territory in region.territories" :key="territory.id">
                            <!-- <v-list dense>
                                <v-list-tile>
                                <v-list-tile-content class="body-2">Id</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{territory.id}}</v-list-tile-content>
                                </v-list-tile>
                            </v-list> -->
                            <a @click.prevent="onShowTerritoryCard(territory)">
                                {{territory.id}}
                            </a>
                            <!-- {{territory.id}} -->
                        </v-flex>
                    </v-layout>
                    <!-- <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small @click.prevent='onEditRegion(region.id)'>Edit</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> -->
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
    props: ['regions'],
    components: {
    },
    data() {
        return {}
    },
    computed: {
        // showTerritoryPopup () {
        //     return !!this.territoryToShow
        // },
        // showTerritoryEditPopup () {
        //     return !!this.territoryIdToEdit
        // },
    },
    methods: {
        // onCloseRegionEdit() {
        //     this.$emit('reloadRegions')
        // },
        onEditRegion(id) {
            this.$emit('onEditRegion', id)
        },
        onShowTerritoryCard(territory) {
            this.$emit('onShowTerritoryCard', territory)
        },
        onEditTerritory(id) {
            // console.log('id:' + id)
            this.$emit('onEditTerritory', id)
        },

        // onCloseTerritory() {
        //     this.territoryToShow = null
        // },
    },
}
</script>
